import jQuery from 'jquery';

jQuery(document).ready(function ($) {

    $(window).resize(function () {
        searchFn();
    });

    function searchFn() {
        // top search box
        let searchBox = $('.search-box'),
            searchBtn = $('#search-btn'),
            body = $('body'),
            sField = $('.s-field'),
            searchOverlay = $(".overlay-body-search");

        searchBtn.click(function () {
            searchBox.css('top', '0');
            searchOverlay.toggleClass('show');
            body.toggleClass('search-open');
            sField.focus();
        });

        $('#s-close').click(function () {
            body.removeClass('search-open');
            searchBox.css('top', '-208px');
            searchOverlay.removeClass('show');
        });

        $('#s, #s-search').keyup(function () {
            if ($(this).val() == '') {
                $('#s-submit, #searchsubmit').prop('disabled', true);
            } else {
                $('#s-submit, #searchsubmit').prop('disabled', false);
            }
        }).keyup();

    }

    searchFn();
});